import { isEmpty } from "lodash";
import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let {
    user,
    setGameFooter,
    gameFooter,
    launchCasino,
    setParly,
    parly,
    parlyBet,
    setShowParlyBet,
  } = useContext(AuthProvider);
  const [select, setSelect] = useState("home");
  const [sabaCasinoFooterPopup, setSabaCasinoFooterPopup] = useState(false);

  const handleSelect = (p) => {
    setSelect(p);
  };
  return (
    <div>
     
     
      <nav>
        <ul
          className=""
          style={{ display: "flex", justifyContent: "space-between" }}
        >
       
          <li id="sports">
            <Link
              to="/sports"
              neua="Sports"
              className={select == "sports" ? "ui-link active" : "ui-link"}
              onClick={() => {
                handleSelect("sports");
               
              }}
            >
              <img
                className="icon-sports"
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
                // src={process.env.REACT_APP_MOBILE_URL + '/yourPathHere.jpg' }
              />
              Sports
            </Link>
          </li>

          <li id="inPlay">
            <Link
              to="/inplay"
              neua="In-Play"
              className={select == "inplay" ? "ui-link active" : "ui-link"}
              onClick={() => {
                handleSelect("inplay");
              
              }}
            >
              <img
                className="icon-inplay"
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              In-Play
            </Link>
          </li>

          <li
            id="home"
            className={select == "home" ? "main-nav active" : "main-nav"}
            onClick={() => {
              handleSelect("home");
              
            }}
          >
            <Link to="/home" neua="Home">
              <img
                className="icon-home"
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              Home
            </Link>
          </li>

          <li id="multiMarket">
            <Link
              to="/multimarket"
              neua="Multi Markets"
              className={select == "multi" ? "ui-link active" : "ui-link"}
              onClick={() => {
                handleSelect("multi");
               
              }}
            >
              <img
                className="icon-pin"
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              
              Multi Market
            </Link>
          </li>

          <li id="account">
            <Link
              to={user ? "/profile" : "/login"}
              className={select == "account" ? "ui-link active" : "ui-link"}
              onClick={() => {
                handleSelect("account");
             
              }}
            >
              <img
                className="icon-account"
                src={
                  process.env.REACT_APP_MOBILE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt=""
              />
              Account
            </Link>
          </li>
        </ul>
      </nav>
      
      {["match-details", "inplay"]?.includes(
        location?.pathname?.split("/")[1]
      ) &&
        parly &&
        !isEmpty(user) &&
        parlyBet?.length > 0 && (
          <div
            onClick={() => {
              setShowParlyBet(true);
            }}
            className="betbtn1 betSlipBtn"
          >
            <img
              src={process.env.REACT_APP_MOBILE_URL + "/assets/images/logoNew.jpeg"}
              className="apana-icon"
              alt=""
            />
            <span>{parlyBet?.length}</span>
          </div>
        )}
    </div>
  );
};

export default Footer;
